import { alpha } from "@mui/material/styles";
import Pagination from "@mui/material/Pagination";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import { FS } from "@plannel/utils/font-util";

const CONTROL_H = 32;   // 페이지 버튼(MUI 기본 32px)에 셀렉트 높이를 맞춘다

/*
 * 페이지 버튼.
 *   MUI 기본은 모서리 4px 에 선택 상태가 `rgba(0,0,0,.08)` 회색 배경뿐이고 글자색은
 *   다른 페이지와 같아서, 지금 몇 페이지에 있는지가 잘 안 읽혔다. 선택 페이지는 primary 로
 *   채우고 모서리는 앱 공통 컨트롤 규격(index.js 의 CONTROL_RADIUS = 8px)에 맞춘다.
 *   ⚠ 갈 수 없는 방향(첫/이전 등)을 흐리게 하는 건 MUI 가 `Mui-disabled` 로 이미 하고 있다.
 */
const PAGINATION_SX = {
  "& .MuiPaginationItem-root": {
    borderRadius: "8px",
    fontSize: FS.TITLE,
    "&:hover": { backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08) },
    "&.Mui-selected": {
      backgroundColor: "primary.main",
      color: "primary.contrastText",
      fontWeight: 500,
      "&:hover": { backgroundColor: "primary.dark" },
    },
  },
};

/*
 * 행 수 셀렉트.
 *   원래 `variant="standard"`(밑줄)이라 앱에서 거의 유일하게 밑줄 입력이었다 — 아웃라인으로
 *   바꿔 다른 필터/검색 입력과 같은 모양이 되게 한다(모서리 8px 는 테마가 준다).
 *   기본 높이(small 40px)는 페이지 버튼보다 커서 줄이 어긋나므로 32px 로 맞춘다.
 */
const PAGE_SIZE_SX = {
  height: CONTROL_H,
  fontSize: FS.TITLE,
  "& .MuiSelect-select": { paddingTop: 0, paddingBottom: 0, paddingLeft: "10px" },
};

const PaginationContainer = ({  currentPage,    // current page index
                                totalPages,     // total number of pages
                                pageSize,       // number of rows per page
                                pageSizes,      // list of number of rows per page
                                setCurrentPage, // set current page index
                                setPageSize     // set number of rows per page
                            }) => {

  const handlePageChange = (event, pageNum) => {
    setCurrentPage(pageNum);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setCurrentPage(1);
  };

  return (
    <Box id={"pagination-container"} sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: 1}}>
      <Pagination count={ totalPages } page={ currentPage } onChange={ handlePageChange } shape="rounded" showFirstButton showLastButton sx={PAGINATION_SX} />
      {/* 카드/갤러리형 목록은 한 페이지 개수가 사용자 선택이 아니라 레이아웃이다.
          pageSizes 를 넘기지 않으면 선택기를 그리지 않는다 — 기존 84개 화면은 모두 넘기므로 영향 없음 */}
      {pageSizes?.length > 1 && (
        <FormControl size="small" sx={{ ml: 2, minWidth: 72 }}>
          <Select value={pageSize} onChange={handlePageSizeChange} sx={PAGE_SIZE_SX} >
            {pageSizes.map((size) => (
               <MenuItem id={"pagination-menu-item"} key={ size } value={ size }>
                 { size }
               </MenuItem>
             ))}
          </Select>
        </FormControl>
      )}
    </Box>
  );
};

export default PaginationContainer;
